var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3OutdoorTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 20.22V57H31v-4h37V22.43L43.28 6.31 18 22.44V24h-4v-3.79L43.3 1.55 72 20.22zM25 55.79a11.68 11.68 0 11-18-.47V29h18v26.79zM23.5 63a7.67 7.67 0 00-2-5.14l-.5-.57V33H11v24l-.59.59A7.69 7.69 0 1023.5 63zM18 59.55V36h-4v23.55a4 4 0 104 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Outdoor_temperature.74885b9b.svg";
export { SvgB3OutdoorTemperature as ReactComponent };